const reasons = [
  {
    icon: 'ri-search-eye-line',
    title: 'Диагностика до обучения',
    desc: 'Мы не начинаем с готовой презентации. Сначала разбираемся, какие управленческие задачи действительно существуют в компании, а не какие темы есть в стандартной программе.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Реальные кейсы',
    desc: 'Работаем не только с абстрактными ситуациями, но и с реальными управленческими задачами участников. Это повышает практическую применимость обучения на 40-60%.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Практика',
    desc: 'Минимум теории ради теории. Инструменты отрабатываются в упражнениях, ролевых ситуациях и кейсах. Участники не слушают — они делают.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Адаптация',
    desc: 'Программа корректируется под специфику компании, отрасль, уровень руководителей и конкретные бизнес-задачи. Нет двух одинаковых программ.',
  },
  {
    icon: 'ri-compass-3-line',
    title: 'Сопровождение',
    desc: 'После обучения при необходимости продолжается работа с командой и реальными ситуациями. Это повышает вероятность закрепления навыков в практике.',
  },
  {
    icon: 'ri-archive-line',
    title: 'Систематизация',
    desc: 'После программы компания может получить инструменты, алгоритмы, чек-листы и другие материалы, которые можно использовать для дальнейшего развития руководителей.',
  },
];

export default function WhyProgramsWorkSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Почему наши программы работают
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Обучение не заканчивается тренингом. Вот почему руководители действительно меняют управленческое поведение, а не просто получают новые знания.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {reasons.map((reason, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-100 p-5 md:p-6 hover:border-teal-200 transition-colors group">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${reason.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{reason.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{reason.desc}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-base md:text-lg font-medium text-gray-800 mt-10 max-w-3xl mx-auto leading-relaxed">
          Наша задача — не провести ещё один тренинг, а помочь руководителям применять инструменты в реальной работе.
        </p>
      </div>
    </section>
  );
}